import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import useGlobalLabels from '@/shared/content/useGlobalLabels';
import siteContextStore, { GlobalLabels } from '@/shared/content/site-context.store';
import { computed, Ref } from 'vue';
import { LinkModel } from '@/types/B2CcontentServerContract';
import siteContextService from '@/b2c/shared/site-context.service';
import { router } from '@/core/router';
import { QueryKeys } from '@/shared/config/route-query.config';


export default /*#__PURE__*/_defineComponent({
  __name: 'LogInOrSignUpLinks',
  setup(__props) {

const globalLabels = useGlobalLabels(GlobalLabels.logInOrSignUp);

const loginLinkHtml = computed(() => {
    if (!loginLink.value) {
        return globalLabels.loginText;
    }
    return `
        <a class="c-link c-magic-line"
        href="${loginLink.value.url}?${QueryKeys.ReturnUrl}=${returnUrl.value}">
            ${globalLabels.loginText}
        </a>`;
});

const signUpLinkHtml = computed(() => {
    if (!createProfileLink.value) {
        return globalLabels.signupText;
    }
    return `
        <a class="c-link c-magic-line"
        href="${createProfileLink.value.url}">
            ${globalLabels.signupText}
        </a>`;
});

const loginLink: Ref<LinkModel> = computed(() => {
    return siteContextStore.settings.loginLink;
});

const createProfileLink: Ref<LinkModel> = computed(() => {
    return siteContextService.settings.createProfileLink ?? {} as LinkModel;
});

const returnUrl = computed(() => {
    return router.currentRoute.value.fullPath;
});


return (_ctx: any,_cache: any) => {
  const _directive_delegate_html_links = _resolveDirective("delegate-html-links")!

  return _withDirectives((_openBlock(), _createElementBlock("span", {
    class: "magic-line-on-child-links text-dusty-grey-on-child-links",
    innerHTML: _ctx.$dictionary.formatNamed(_unref(globalLabels).logInOrSignupText,
                                          {login: _unref(loginLinkHtml), signup: _unref(signUpLinkHtml)})
  }, null, 8, _hoisted_1)), [
    [_directive_delegate_html_links]
  ])
}
}

})